export default __webpack_public_path__ + "static/media/625.aca16ea4.png";